<template>
  <div>
    <div class="row">
      <div class="col-md-12 ml-auto mr-auto">
        <card class="card-subcategories card-plain">
          <template slot="header">
            <h4 class="card-title text-center">
              {{ $t("sender:profile.text") }}
            </h4>
            <br />
          </template>

          <tabs
            type="primary"
            tabContentClasses="col-md-12"
            square
            centered
            class="row justify-content-center"
          >
            <tab-pane>
              <span slot="label">
                <i class="tim-icons icon-badge"></i
                ><span>{{ $t("sender:labels.general") }} </span>
              </span>
              <general-panel></general-panel>
            </tab-pane>

            <tab-pane>
              <span slot="label">
                <i class="tim-icons icon-settings"></i
                ><span>{{ $t("sender:labels.settings") }} </span>
              </span>
              <settings-panel></settings-panel>
            </tab-pane>

            <tab-pane>
              <span slot="label">
                <i class="tim-icons icon-spaceship"></i
                ><span>{{ $t("sender:labels.my_plan") }} </span>
              </span>
              <card class="card-black">
                <my-plan></my-plan>
              </card>
            </tab-pane>
          </tabs>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { TabPane, Tabs } from "../../components";
import SettingsPanel from "./settings/SettingsPanel";
import MyPlan from "./wizard/MyPlan";
import GeneralPanel from "./general/GeneralPanel.vue";

export default {
  components: {
    TabPane,
    Tabs,
    SettingsPanel,
    MyPlan,
    GeneralPanel
  },
  data() {
    return {};
  }
};
</script>
